import { useState } from "react";
import { TextField, Button, Box, Typography, Alert } from "@mui/material";
import { Lock, LockOpen, CheckCircle } from "@mui/icons-material";
import { getAuth, reauthenticateWithCredential, updatePassword, EmailAuthProvider } from "firebase/auth";
import Header from "../Homepage/Components/Header";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const UpdatePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("error"); // "success" or "error"
  const navigate = useNavigate(); // Initialize navigate

  const handlePasswordUpdate = async () => {
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match!");
      setMessageType("error");
      return;
    }

    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      setMessage("User is not logged in!");
      setMessageType("error");
      return;
    }

    try {
      // Re-authenticate the user
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);

      // Update the password
      await updatePassword(user, newPassword);
      setMessage("Password updated successfully!");
      setMessageType("success");
      navigate("/"); // Change "/" to the path you want to navigate to
    } catch (error) {
      console.error(error);
      setMessage(error.message || "Failed to update the password.");
      setMessageType("error");
    }
  };

  return (
    <Box>
      <Header />

      <Box
        sx={{
          maxWidth: 400,
          margin: "32px auto",
          padding: "24px",
          borderRadius: "16px",
          background: "linear-gradient(135deg, #f3f4f6, #ffffff)",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            fontFamily: "'Work Sans', sans-serif",
            marginBottom: "16px",
            color: "#333",
            textAlign: "center",
          }}
        >
          Update Your Password
        </Typography>

        {message && (
          <Alert
            severity={messageType}
            sx={{
              marginBottom: "16px",
              borderRadius: "8px",
              fontFamily: "'Work Sans', sans-serif",
              fontSize: "0.9rem",
            }}
          >
            {message}
          </Alert>
        )}

        <Box sx={{ position: "relative", marginBottom: "16px" }}>
          <TextField
            label="Current Password"
            type="password"
            fullWidth
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                paddingLeft: "48px", // Adds space for the icon
              },
            }}
            InputProps={{
              startAdornment: (
                <LockOpen
                  sx={{
                    position: "absolute",
                    left: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#999",
                  }}
                />
              ),
            }}
          />
        </Box>

        <Box sx={{ position: "relative", marginBottom: "16px" }}>
          <TextField
            label="New Password"
            type="password"
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                paddingLeft: "48px", // Adds space for the icon
              },
            }}
            InputProps={{
              startAdornment: (
                <Lock
                  sx={{
                    position: "absolute",
                    left: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#999",
                  }}
                />
              ),
            }}
          />
        </Box>

        <Box sx={{ position: "relative", marginBottom: "16px" }}>
          <TextField
            label="Confirm New Password"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                paddingLeft: "48px", // Adds space for the icon
              },
            }}
            InputProps={{
              startAdornment: (
                <Lock
                  sx={{
                    position: "absolute",
                    left: 12,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#999",
                  }}
                />
              ),
            }}
          />
        </Box>

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handlePasswordUpdate}
          sx={{
            fontWeight: "bold",
            textTransform: "none",
            padding: "12px",
            borderRadius: "8px",
            backgroundColor: "#4CAF50",
            "&:hover": { backgroundColor: "#45A049" },
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <CheckCircle sx={{ marginRight: "8px" }} />
          Update Password
        </Button>
      </Box>
    </Box>
  );
};

export default UpdatePassword;
